import React from 'react';

import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { ApplicationUuid, ResponseItem } from '@bringg/types';
import { DetailedCellProps, getTaskStatusClass } from '@bringg-frontend/monitoring-shared';

import { useStores } from 'bringg-web/recipes';
import StatusDot from '../../../../../shared/components/status-dot/status-dot';

import styles from './status-cell.module.scss';

const StatusCell = ({ row }: DetailedCellProps<ResponseItem>) => {
	const { id } = row;
	const { merchantConfigurationsStore } = useStores();
	const isRealtimeEtaEnabled = !!merchantConfigurationsStore.findApplication(ApplicationUuid.RealtimeEtaApp);
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(id);

	return (
		<div className={styles.dotWrapper}>
			<StatusDot statusClass={getTaskStatusClass(task, isRealtimeEtaEnabled)} />
		</div>
	);
};

export default StatusCell;
